import { call, put } from "redux-saga/effects";
import { updateItemFailure } from "../actions";
import { UpdateItemRequestProps, updateItemRequest } from "../api";
import { ListFieldsKeys } from "src/api/config";

export function* updateDefaultSaga<K extends ListFieldsKeys>(payload: UpdateItemRequestProps<K>) {
  try {
    if (payload) {
      const ID: number[] = yield call(updateItemRequest, payload);
      return ID;
    }
  } catch (error) {
    console.log(error);
    yield put(updateItemFailure({ listName: payload.listName, error }));
  }
}
